import { useEffect } from 'react'
import { useAuthStore } from '@/lib/store'
import { useSupabase } from '@/lib/hooks/use-supabase'
import { createStoredProcedures, initializeDatabaseSchema } from '@/lib/schema'

export function AuthProvider({ children }: { children: React.ReactNode }) {
  const { isReady, error } = useSupabase()
  const loadUser = useAuthStore((state) => state.loadUser)
  const loading = useAuthStore((state) => state.loading)

  useEffect(() => {
    let mounted = true

    const initializeAuth = async () => {
      if (isReady && mounted) {
        try {
          await loadUser()
          
          // Initialize database schema
          await createStoredProcedures()
          await initializeDatabaseSchema()
        } catch (err) {
          console.error('Error loading user:', err)
        }
      }
    }

    initializeAuth()

    return () => {
      mounted = false
    }
  }, [isReady, loadUser])

  if (!isReady || loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
      </div>
    )
  }

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="bg-red-50 border border-red-200 rounded-lg p-4 max-w-md">
          <h2 className="text-lg font-medium text-red-800">
            Connection Error
          </h2>
          <p className="mt-2 text-sm text-red-600">
            {error.message}
          </p>
          <p className="mt-4 text-sm text-gray-500">
            Please refresh the page or contact support if the problem persists.
          </p>
        </div>
      </div>
    )
  }

  return <>{children}</>
}